import { render, staticRenderFns } from "./DocumentTreeDocItem.vue?vue&type=template&id=61cf2d84&scoped=true&"
import script from "./DocumentTreeDocItem.vue?vue&type=script&lang=ts&"
export * from "./DocumentTreeDocItem.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentTreeDocItem.vue?vue&type=style&index=0&id=61cf2d84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cf2d84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VListItemTitle,VRow,VTextField})
